<template>
  <section>
    <v-container container--fluid grid-list-xl class="px-0">
      <v-row class="px-4">
        <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h1 :class="{'text-little': $vuetify.breakpoint.smAndDown}">Delivery Exceptions</h1>
        </v-col>
      </v-row>

      <v-row align="center" justify="space-around" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
        <v-col md="2" cols="12">
          <v-text-field
            v-model="search"
            label="Search..."
            prepend-icon="fas fa-search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="10" md="1" sm="10" :offset-xs2="!isInternalUser">
          <v-dialog
            ref="dialogFrom"
            v-model="dateFromDialog"
            :return-value.sync="dateFrom"
            close-on-content-click
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateFrom"
                label="Date Start"
                v-on="on"
                class="ma-0"
                readonly
              >
              </v-text-field>
            </template>
            <v-date-picker v-model="dateFrom" @input="$refs.dialogFrom.save(dateFrom)" @change="getDeliveriesExceptions">
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="10" md="1" sm="10" :offset-xs2="!isInternalUser">
          <v-dialog
            ref="dialog"
            v-model="dateDialog"
            :return-value.sync="dateEnd"
            close-on-content-click
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateEnd"
                label="Date End"
                v-on="on"
                class="ma-0"
                readonly
              >
              </v-text-field>
            </template>
            <v-date-picker v-model="dateEnd" @input="$refs.dialog.save(dateEnd)" @change="getDeliveriesExceptions">
            </v-date-picker>
          </v-dialog>
        </v-col>

        <v-col cols="10" md="2" sm="10">
          <v-select
            :items="exportChoices"
            v-model="SelectedStatus"
           clearable
            label="Status"
            class="ma-0"
          >
          </v-select>
        </v-col>

        <v-col cols="10" md="2" sm="10">
          <v-select
            :items="reasonCodes"
            v-model="SelectedReasonCode"
            clearable
            label="Reason Code"
            class="ma-0"
          >
          </v-select>
        </v-col>

        <v-col cols="10" md="2" sm="10" v-if="isInternalUser">
          <v-autocomplete
            clearable
            :items="clients"
            v-model="clientAutocomplete"
            v-on:change="getDeliveriesExceptions"
            return-object
            item-text="name"
            label="Pick a client..."
            prepend-icon="fas fa-user"
            class="ma-0"
          >
          </v-autocomplete>
        </v-col>

        <v-col md="2" sm="10" class="align-center justify-space-around" style="display: inline-flex">
          <v-menu offset-y>
            <template v-slot:activator="{ on: menuList }">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn icon large color="blue darken-1" v-on="menuList" class="white--text">
                    <v-icon v-on="tooltip">cloud_download</v-icon>
                  </v-btn>
                </template>
                <span>Export CSV</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item
                v-for="(choice, index) in exportChoices"
                :key="index"
              >
                <v-list-item-icon>
                  <download-csv
                    class="btn btn-default"
                    :data="csvExport(choice.value)"
                    name="exportDeliveries.csv">
                    <v-btn icon large>
                      <v-icon :color="choice.color">cloud_download</v-icon>
                    </v-btn>
                    </download-csv>
                </v-list-item-icon>
                <v-list-item-title>{{choice.text}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!--          <v-menu offset-y>-->
          <!--              <v-list>-->
          <!--              <v-list-item-->
          <!--                v-for="(choice, index) in exportChoices"-->
          <!--                :key="index"-->
          <!--                return-object-->
          <!--              >-->
          <!--                <v-list-item-title>{{choice.text}}</v-list-item-title>-->
          <!--                <download-csv-->
          <!--                  class="btn btn-default"-->
          <!--                  :data="choice.value"-->
          <!--                  name="filename.csv">-->
          <!--                  <v-btn icon large color="blue darken-1">-->
          <!--                    <v-icon>cloud_download</v-icon>-->
          <!--                  </v-btn>-->
          <!--                </download-csv>-->
          <!--              </v-list-item>-->
          <!--              </v-list>-->
          <!--          </v-menu>-->


          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="blue darken-1 headline" text v-on="on" @click="info = !info">
                <span class="v-btn__content" style="font-size: 22px;">?</span>
              </v-btn>
            </template>
            <span>Display the reason code legend</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-alert :value="info" type="info" color="blue darken-1" transition="slide-y-transition" class="mb-0">
        <v-row>
          <v-col cols="12" md="4" class="text-center">
            CNX
            <v-icon>arrow_right_alt</v-icon>
            Canceled by Vendor <br>
            R
            <v-icon>arrow_right_alt</v-icon>
            Rejected by Receiver<br>
            RREC
            <v-icon>arrow_right_alt</v-icon>
            Rejected by reception<br>
            GNR
            <v-icon>arrow_right_alt</v-icon>
            Goods Not Received<br>
            G
            <v-icon>arrow_right_alt</v-icon>
            Goods Not Received<br>
            U
            <v-icon>arrow_right_alt</v-icon>
            Unit information Missing<br>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            DG
            <v-icon>arrow_right_alt</v-icon>
            Damaged Goods<br>
            BC
            <v-icon>arrow_right_alt</v-icon>
            Business Closed<br>
            BA
            <v-icon>arrow_right_alt</v-icon>
            Bad Address<br>
            A
            <v-icon>arrow_right_alt</v-icon>
            Unable to locate address<br>
            I
            <v-icon>arrow_right_alt</v-icon>
            Inaccessible drop zone<br>
            S
            <v-icon>arrow_right_alt</v-icon>
            Secure Gate / Complex<br>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            B
            <v-icon>arrow_right_alt</v-icon>
            Road block / closure<br>
            DT
            <v-icon>arrow_right_alt</v-icon>
            Damaged in Transit<br>
            ORC
            <v-icon>arrow_right_alt</v-icon>
            Cancelled by Client en route<br>
            O
            <v-icon>arrow_right_alt</v-icon>
            Other<br>
          </v-col>
        </v-row>
      </v-alert>

      <transition name="slide-x-transition">
        <v-progress-linear v-if="loading" :indeterminate="loading"></v-progress-linear>
      </transition>

      <v-data-table
        :search="search"
        :headers="headers"
        :items="displayItemsWithStatus"
        :items-per-page="20"
        :sort-by="'client_name'"
        v-model="selected"
        show-select
        item-key="tracking"
      >
        <template v-slot:item="props">
          <tr :style="getRowStyle(props.item)"  >
            <td>
              <v-checkbox
                class="justify-center"
                :input-value="props.isSelected"
                @change="toggleSelect(props.item, $event)"
                primary
                hide-details
                :disabled="props.item.status !== 'On Hold'"
              />
            </td>
              <td   v-for="(header, index) in headers"
                    :key="index"
                    class="text-center"
                    v-if="header.value !== 'actual_time'"
                    @click="rowSelected(props.item)"
                >
                {{ props.item[header.value] }}
              </td>

              <td v-else class="text-center">
                   {{(props.item.actual_time)}}
               </td>
          </tr>
        </template>
      </v-data-table>
      <v-card-actions class="justify-center">
        <v-btn text color="blue darken-1" @click="triggerCancel"  :disabled="this.selected.length === 0"
               v-show="isInternalUser"
        >Cancel All</v-btn>
      </v-card-actions>
    </v-container>


    <DeliveryInfoDisplayer
      :tracking="selectedTracking"
      :showProp="showInfo"
      v-on:close="toggleInfoDisplayer"
    ></DeliveryInfoDisplayer>

  </section>
</template>

<script>
    import axios from 'axios'
    import DeliveryInfoDisplayer from "./Search/DeliveryInfoDisplayer";
    import moment from 'moment';
    import DeliveryCancelDialog from "./Search/DeliveryCancelDialog.vue";

    export default {
        name: "ExceptionsPage",
        components: {
          DeliveryCancelDialog,
            DeliveryInfoDisplayer,
        },
        data() {
            return {
                headers: [
                    {text: 'Service', value: 'service_name', align: 'center'},
                    {text: 'Name', value: 'name', align: 'center', sortable: true},
                    {text: 'Address', value: 'street1', align: 'center', sortable: true},
                    {text: 'Postcode', value: 'postcode', align: 'center', sortable: true},
                    {text: 'Reason Code', value: 'reason_code', align: 'center', sortable: true},
                    {text: 'Region', value: 'region_name', align: 'center', sortable: true},
                    {text: 'Invoice No', value: 'invoice', align: 'center', sortable: true},
                    {text: 'Tracking Id', value: 'tracking', align: 'center', sortable: true},
                    {text: 'Client Name', value: 'client_name', align: 'center', sortable: true},
                    {text: 'Status', value: 'status', align: 'center', sortable: true},
                    {text: 'Date', value: 'date', align: 'center', sortable: true},
                    {text: 'Time', value: 'actual_time', align: 'center', sortable: true},
                ],
                exportChoices: [
                    {text: 'Rescheduled Deliveries', value: 'rescheduled', color: 'rgb(105,255,128)'},
                    {text: 'On Hold Deliveries', value: 'on hold', color: 'rgb(255,229,95)'},
                    {text: 'Canceled Deliveries', value: 'canceled', color: 'rgb(255,179,186)'},
                    {text: 'All Exceptions', value: 'all', color: 'blue'},
                ],
                search: '',
                info: false,
                rescheduledCard: true,
                onHoldCard: true,
                canceledCard: true,
                clientAutocomplete: null,
                SelectedStatus: null,
                dateDialog: false,
                dateFromDialog:false,
                exceptions: [],
                loading: false,
                dateEnd: null,
                dateFrom:null,
                showInfo: false,
                selectedTracking: null,
                reasonCodes:[],
                SelectedReasonCode:null,
                selected: [],
                displayItemsWithStatus: [],
                cancelDialog:false,
                isLoaded: false,
                code: null,
                note: null,
                codes: [
                  {code: 'CNX', text: 'Cancelled by Client'},
                  {code: 'OOA', text: 'Out of Area'},
                  {code: 'GNR', text: 'Goods Not Received'},
                  {code: 'MS', text: 'Miss Sort'},
                  {code: 'W', text: 'Withheld'},
                  {code: 'OR', text: 'Other'},
                ]
            }
        },
        mounted: function () {
            this.date = moment().format('YYYY-MM-DD');

          if (this.dateFrom !== null && this.dateEnd !== null) {
            let suffix = '/deliveries/exceptions?dateFrom=' + this.dateFrom + '&dateEnd=' + this.dateEnd;

                this.loading = true;
                axios.get(process.env.API_URL + suffix)
                    .then((response) => {
                        this.exceptions = response.data;
                        this.loading = false;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar','ERROR ' + response.response.data.error);
                        this.loading = false;
                    });
          } else {
              this.$store.commit('displaySnackbar', 'Please fill the date field');
          }
        },
        methods: {
            moment() {
                return moment();
            },
            csvExport(choice) {
                let arrData;
                if (choice === 'rescheduled') {
                    arrData = this.rescheduled;
                } else if (choice === 'on hold') {
                    arrData = this.onHold;
                } else if (choice === 'canceled') {
                    arrData = this.canceled;
                } else {
                    arrData = this.exceptions;
                }

                    return arrData;

            },
            // csvExport(choice) {
            //     let arrData;
            //     if (choice === 'rescheduled') {
            //         arrData = this.rescheduled;
            //     } else if (choice === 'on hold') {
            //         arrData = this.onHold;
            //     } else if (choice === 'canceled') {
            //         arrData = this.canceled;
            //     } else {
            //         arrData = this.exceptions;
            //     }
            //
            //     if (arrData.length > 0) {
            //         let csvContent = "data:text/csv;charset=utf-8,";
            //
            //         csvContent += [
            //             Object.keys(arrData[0]).join(","),
            //             ...arrData.map(item => {
            //                 let row = Object.values(item).map((value) => {
            //                     return '\"' + value + '\"'
            //                 });
            //                 return row.join(",")
            //             })
            //         ]
            //             .join("\n")
            //             .replace(/(^\[)|(\]$)/gm, "");
            //
            //         const data = encodeURI(csvContent);
            //         const link = document.createElement("a");
            //         link.setAttribute("href", data);
            //         link.setAttribute("download", choice + ".csv");
            //         link.click();
            //     } else {
            //         this.displaySnackbar('Couldn\'t export ' + choice + ' exceptions because the array is empty')
            //     }
            // },
            getDeliveriesExceptions() {
                if (this.dateFrom !== null && this.dateEnd !== null) {
                    let suffix = '/deliveries/exceptions?dateFrom=' + this.dateFrom + '&dateEnd=' + this.dateEnd;

                    if (this.clientAutocomplete !== null && this.clientAutocomplete !== undefined) {
                        suffix = suffix + '&client=' + this.clientAutocomplete.id
                    }

                    this.loading = true;
                    axios.get(process.env.API_URL + suffix)
                        .then((response) => {
                            this.exceptions = response.data;
                            this.displayItemsWithStatus = this.exceptions;
                            this.exceptions.filter((excep) => {
                              if(excep.reason_code === null || excep.reason_code === '') {
                                excep.reason_code = 'O';
                              }
                              this.reasonCodes.push(excep.reason_code)
                            });
                            this.loading = false;
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                            this.loading = false;
                        });
                }
            },
            // @vuese
            // Triggered each time we click on a row, displays further information for the delivery in question
            // @arg Delivery Object on which we clicked
            rowSelected(item) {
                this.selectedTracking = item.tracking;
                this.toggleInfoDisplayer();
            },
            // @vuese
            // Toggles information dialog
            toggleInfoDisplayer() {
                this.showInfo = !this.showInfo;
                if (!this.showInfo) {
                    this.selectedTracking = null;
                }
            },
          getRowStyle(item) {
            if (item.status === 'Rescheduled') {
              return { backgroundColor: 'rgb(186, 255, 201)' };
            }
            if (item.status === 'On Hold') {
              return { backgroundColor: 'rgb(255, 223, 186)' };
            }
            if (item.status === 'Canceled') {
              return { backgroundColor: 'rgba(255, 179, 186, 0.5)' };
            }
            return {};
          },
          toggleSelect(item) {
            const index = this.selected.findIndex(i => i.tracking === item.tracking);
            if (index >= 0 ) {
              this.selected.splice(index, 1);
            } else {
              this.selected.push(item);
            }
            return this.selected;
          },
          customFilter: function (exception) {
              return exception.status.toLowerCase() === this.SelectedStatus.toLowerCase()
          },
          triggerCancel(){
            let proceedAction = 0;
            let error = 0;
            const totalAction = this.selected.length;
            this.loading = true;
            this.selected.forEach( delivery => {
              let body = {
                code: delivery.reason_code,
                note: ''
              };
              if(delivery.status !== 'On Hold'){
                return;
              }
              axios.post(process.env.API_URL + '/deliveries/' + delivery.tracking + '/cancel', body)
                .then((response) => {
                  proceedAction++;
                  if (proceedAction === totalAction){
                    this.$store.commit('displaySnackbar', proceedAction + ' deliveries has been canceled and ' + error + ' deliveries canceled errors');
                    this.loading = false;
                    this.getDeliveriesExceptions();
                  }
                })
                .catch((response) => {
                  if (response.response.data.error === 'Delivery ' + delivery.tracking + ' is not pending'){
                    proceedAction++;
                    error++;
                  } else{
                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    this.loading = false;
                    this.getDeliveriesExceptions();
                  }
                });
            });
          },
        },
        computed: {
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            }
            ,
            onHold() {
                let on_hold = this.exceptions.filter((exception) => {
                    return exception.status === 'On Hold'
                });
                return on_hold
            }
            ,
            rescheduled() {
                let rescheduled = this.exceptions.filter((exception) => {
                    return exception.status === 'Rescheduled'
                });
                return rescheduled
            }
            ,
            canceled() {
                let canceled = this.exceptions.filter((exception) => {
                    return exception.status === 'Canceled'
                });
                return canceled
            }
            ,
            displayItemsWithStatus() {
                if (this.SelectedStatus === null || this.SelectedStatus === 'all') return this.exceptions;
                return this.exceptions.filter(this.customFilter);
            },
        },
        asyncComputed: {
            async clients() {
                if (!this.isInternalUser) return [];
                else return await axios.get(process.env.API_URL + '/clients')
                    .then((response) => {
                        return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((response) => {
                        alert("An unknown error has occurred (Couldn't get clients...)");
                        return [];
                    })
            }
        },
        watch: {
          SelectedReasonCode(newCode) {
            if (!newCode) {
              this.displayItemsWithStatus = this.exceptions;
            } else {
              this.displayItemsWithStatus = this.exceptions.filter((exception) => {
                return exception.reason_code === newCode;
              });
            }
          },
          SelectedStatus(newCode) {
            if (!newCode) {
              this.displayItemsWithStatus = this.exceptions;
            } else {
              this.displayItemsWithStatus = this.exceptions.filter((exception) => {
                return exception.status.toLowerCase() === newCode.toLowerCase();
              });
            }
          }
        },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/ExceptionsPage.vue